<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
                <img :src="campaign.image" :alt="campaign.title">
                <div class="image-overlay"></div>
            </figure>
        </div>
        <div class="card-content campaign-details-content">
            <!--
            <div class="campaign-details-by mb-10">
                {{ campaign.brand.name }} <small style="text-transform: none">x</small> {{ $root.contact.first_name }}
            </div>
            -->
            <h3 v-if="campaign.title">{{ campaign.title }}</h3>
        </div>
    </div>
</template>
<script>
    export default {

        /**
         * The component name
         *
         * @type {string}
         */
        name: 'CampaignImage',

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {

            /**
             * The campaign
             */
            campaign: {
                type: Object,
                required: true
            }
        }
    }
</script>